import { render, staticRenderFns } from "./lists.vue?vue&type=template&id=6ae069f1&scoped=true"
import script from "./lists.vue?vue&type=script&lang=js"
export * from "./lists.vue?vue&type=script&lang=js"
import style0 from "./lists.vue?vue&type=style&index=0&id=6ae069f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae069f1",
  null
  
)

export default component.exports